/**
 * Copyright (c) 2025-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: RemixIcon
// License: Apache License 2.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const BroadcastLine = (props: Props): JSX.Element => (
  <Icon fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="m4.93 2.93 1.41 1.41a7.97 7.97 0 0 0 0 11.32l-1.41 1.41a9.97 9.97 0 0 1 0-14.14m14.14 0a9.97 9.97 0 0 1 0 14.14l-1.41-1.41a7.97 7.97 0 0 0 0-11.32zM7.76 5.76l1.41 1.41a4 4 0 0 0 0 5.66l-1.41 1.41a6 6 0 0 1 0-8.48m8.48 0a6 6 0 0 1 0 8.48l-1.41-1.41a4 4 0 0 0 0-5.66zM12 12a2 2 0 1 1 0-4 2 2 0 0 1 0 4m-1 2h2v8h-2z" />
  </Icon>
);
